import { useEffect, useState, useRef } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import useUserStore from '@lcsc-ui/store/user';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import sendAxios from '@lcsc-ui/utils/request';
import Utils from '@lcsc-ui/utils/Utils';
import { Modal, InputNumber, message, Spin } from 'antd';

import SecondKillModel from './secondKillModel';

import API from '@/apis';

export default function SecondKillDialogDialog({ data, isShowSecondKillDialog, setIsShowSecondKillDialog }) {
  const projectConfigVO = useUserStore((state) => state.projectConfigVO);
  const trackZone = useUserStore((state) => state.fromZone);
  const productRecord = data?.productRecord;
  const secondKillProductVO = data?.secondKillProductVO;
  const [total, setTotalMoney] = useState(0);
  const [catInputNum, setCatInputNum] = useState(secondKillProductVO?.minPurchaseNumber);
  const [buyCartloading, setBuyCartloading] = useState(false);

  const checkGroupRef = useRef(null);

  useEffect(() => {
    const total = (secondKillProductVO?.minPurchaseNumber * secondKillProductVO?.secondKillPrice).toFixed(2);
    setTotalMoney(total);
    setCatInputNum(secondKillProductVO?.minPurchaseNumber || 1);
  }, []);

  const changeNumber = (e) => {
    setCatInputNum(e);
    const total = (e * secondKillProductVO?.secondKillPrice).toFixed(2);
    setTotalMoney(total);
  };

  const changeTotal = (e) => {
    const total = (e * secondKillProductVO?.secondKillPrice).toFixed(2);
    setTotalMoney(total);
  };

  // 跳登录和注册
  const gotoLogin = (type) => {
    const url = Utils.getCasTypeUrl(type);
    window.open(url, '_self');
  };

  const clickCheckGroup = () => {
    const productId = secondKillProductVO?.productId;
    const activityId = secondKillProductVO?.secondKillActivityId;
    const purchaseNumber = catInputNum;
    const minNum = secondKillProductVO?.minPurchaseNumber; // 最小起购数
    const maxNum = secondKillProductVO?.maxPurchaseNumber; // 最大限购数
    const purchaseLimitType = secondKillProductVO?.purchaseLimitType;
    const minWholeNumber = data?.productRecord?.minWholeNumber;
    // 限制小于个人起购下单
    if (purchaseNumber < minNum) {
      message.warning(`最小起订量为${minNum}，已为您修正。`);
      setCatInputNum(minNum);
      changeTotal(minNum);
      return;
    }
    // 限制超过个人限购下单
    if (maxNum > 0 && purchaseNumber > maxNum) {
      message.warning(`单人限购${maxNum}，已为您修正。`);
      setCatInputNum(maxNum);
      changeTotal(maxNum);
      return;
    }
    if (purchaseLimitType === 'min_whole_number') {
      // 加购限制为 整包
      if (purchaseNumber % minWholeNumber !== 0) {
        message.warning(`必须以${minWholeNumber}的倍数购买，已为您修正。`);
        setCatInputNum(purchaseNumber + (minWholeNumber - (purchaseNumber % minWholeNumber)));
        changeTotal(purchaseNumber + (minWholeNumber - (purchaseNumber % minWholeNumber)));
        return;
      }
    }
    buriedPoint({
      cp: 'product_detail',
      ty: 'click',
      op: 'BUY_NOW',
      data: {
        track_zone: trackZone,
        pc: productRecord?.productCode,
        no: purchaseNumber,
        sence: 'secondkill_now',
        price: total,
      },
    });
    setBuyCartloading(true);
    sendAxios({
      method: 'GET',
      baseURL: 'lcscItemUrl',
      url: `${API.asyncSecondKillValidatePerfect}?productId=${productId}&purchaseNumber=${purchaseNumber}&activityId=${activityId}`,
    })
      .then((res) => {
        if (res.needLogin) {
          gotoLogin();
        }
        if (res.code === 200) {
          let url = `${projectConfigVO.lcscOrderUrl}/member/perfect/ms.html?productId=${productId}&purchaseNumber=${purchaseNumber}&trackZone=${trackZone}&activityId=${activityId}`;

          if (checkGroupRef.current) {
            url = Utils.getBtnSpmQueryUrl(url, checkGroupRef.current);
          }

          window.open(url, '_self');
        } else if (res.msg === 'needChooseCusType') {
          // window.getCustomerType();
          // const confirmCustomerTypeDom = document.getElementById('page-confirm-customer-type');
          // if (confirmCustomerTypeDom) {
          //   confirmCustomerTypeDom.style.display = 'block';
          // }
          message.error('需要验证账户类型');
        } else {
          if (res.msg === '请登录后操作' || res.needLogin) {
            message.error('请登录后操作', () => {
              window.location.href = '/login.html';
            });
          } else {
            message.error(res.msg);
          }
        }
      })
      .finally(() => {
        setBuyCartloading(false);
      });
  };

  return (
    <Modal
      data-spm="xms"
      width="500px"
      title={`商品秒杀（${productRecord?.productName || productRecord?.productCodeManufacturer}）`}
      open={isShowSecondKillDialog}
      onCancel={() => setIsShowSecondKillDialog(false)}
      centered
      footer={null}
    >
      <div className="text-center mt-[20px] flex justify-center items-center">
        <span>数量 </span>
        <InputNumber
          controls={false}
          size="mini"
          value={catInputNum}
          min={0}
          precision={0}
          maxLength={8}
          className="w-[92px] mx-[10px]"
          onChange={changeNumber}
        />
        × <span className="text-[#ff7800] ml-[10px]">{secondKillProductVO?.secondKillPrice}</span> =
        <span className="text-[#ff7800] ml-[10px]">{total}</span>
        <Spin indicator={<LoadingOutlined spin />} size="small" spinning={buyCartloading}>
          <button
            data-spm="buy"
            ref={checkGroupRef}
            className="w-[97px] h-[28px] text-[#fff] text-[14px] bg-[#0093e6] text-center rounded ml-[20px]"
            onClick={clickCheckGroup}
          >
            秒杀
          </button>
        </Spin>
      </div>

      <div className="text-[14px] mt-[20px] bg-[#f9f9f9] pl-[10px]">
        <SecondKillModel secondKillProductVO={secondKillProductVO} />
      </div>
    </Modal>
  );
}
